type EmptyFieldPlaceholder = '--';

export const EMPTY_FIELD_PLACEHOLDER: EmptyFieldPlaceholder = '--';
